const vant = require('vant')
import * as hiLinkDefault from "../../static/js/default.js";

const Axios = axios.create({
  baseURL: process.env.API_ROOT,
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    // "Content-Type": "multipart/form-data",
    // 'cpid': this.$default.medical.cpid,
    'appName':  'jcring'
  }
});

//POST传参序列化
Axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 返回状态判断
Axios.interceptors.response.use((res) => {
  if (res.status != 200) {
    return Promise.reject(res);
  }
  // 如果是正常情况 且返回中无data前端需要message判断
  if (!res.data) {
    return res || {};
  }
  return res.data || {};
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        // vant.Toast(`请求错误: ${err.response.data.data}`);
        // vant.Toast('请求错误');
        vant.Toast(errorToast(1));
        break
      case 401:
        // vant.Toast('token无效');
        vant.Toast(errorToast(3));
        break
      case 403:
        // vant.Toast('拒绝访问');
        vant.Toast(errorToast(3));
        break
      case 404:
        // vant.Toast(`请求地址出错: ${err.response.config.url}`);
        vant.Toast(errorToast(1));
        break
      case 408:
        // vant.Toast('请求超时');
        vant.Toast(errorToast(2));
        break
      case 500:
        // vant.Toast('服务器内部错误');
        vant.Toast(errorToast(1));
        break
      case 501:
        // vant.Toast('服务未实现');
        vant.Toast(errorToast(3));
        break
      case 502:
        // vant.Toast('网关错误');
        vant.Toast(errorToast(3));
        break
      case 503:
        // vant.Toast('服务不可用');
        vant.Toast(errorToast(3));
        break
      case 504:
        // vant.Toast('网关超时');
        vant.Toast(errorToast(3));
        break
      case 505:
        // vant.Toast('HTTP版本不受支持');
        vant.Toast(errorToast(3));
        break
    }
  }
  return Promise.reject(err);
});

function errorToast(number) {
  if (number == 1) {
    return hiLinkDefault.medical.language == 'en' ? 'System error' : '系统错误'
  } else if (number == 2) {
    return hiLinkDefault.medical.language == 'en' ? 'System timeout' : '系统超时'
  } else if (number == 3) {
    return hiLinkDefault.medical.language == 'en' ? 'System abnormal' : '系统异常'
  }
}

// post方法
export function POST(url, params) {
  return new Promise((resolve, reject) => {
    Axios.post(url, params)
      .then(response => {
        if (!response.data) {
          resolve(response);
        }
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// get方法
export function GET(url, params) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
        params
      })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((err) => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js